/**
 * Toast Notification Component
 * Displays toast notifications from the UI store
 */

import { useUIStore } from '@/stores/uiStore';
import { X } from 'lucide-react';
import { Button } from './ui/button';

export function Toast() {
  const { toasts, removeToast } = useUIStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-md">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            flex items-center justify-between gap-3 p-4 rounded-lg shadow-lg border
            animate-in slide-in-from-right duration-300
            ${
              toast.type === 'success'
                ? 'bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800 text-green-900 dark:text-green-100'
                : toast.type === 'error'
                ? 'bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 text-red-900 dark:text-red-100'
                : 'bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800 text-blue-900 dark:text-blue-100'
            }
          `}
        >
          <p className="text-sm font-medium flex-1">{toast.message}</p>
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={() => removeToast(toast.id)}
            className="shrink-0 hover:bg-transparent"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
